/* eslint-disable react/require-default-props */

import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import {
  Button,
  Fade,
  Modal,
  Paper,
} from '@mui/material';
import useStyles from './styles';

export default function GenericConfirmationModal({
  modals,
  setOpenModal,
  confirmationType,
  confirmedFunction,
  informationalHeader,
  contentOverButtons,
  contentUnderButtons,
}) {
  const classes = useStyles();

  const handleModalClose = () => {
    setOpenModal(confirmationType, false);
  };

  const handleConfirm = () => {
    confirmedFunction();
    setOpenModal(confirmationType, false);
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={modals[confirmationType]}
      closeAfterTransition
    >
      <Fade in={modals[confirmationType]}>
        <Paper className={classes.paper}>
          <div className={classes.topBarWrapper}>
            <h4>
              {informationalHeader}
            </h4>
            <IconButton
              color="secondary"
              aria-label="close"
              className={classes.closeButton}
              onClick={() => handleModalClose()}
              size="large"
            >
              <CloseIcon />
            </IconButton>
          </div>
          {contentOverButtons}
          <Button onClick={handleConfirm} className={classes.button}>Confirm</Button>
          <Button onClick={handleModalClose} className={classes.button}>Cancel</Button>
          {contentUnderButtons}
        </Paper>
      </Fade>
    </Modal>
  );
}

GenericConfirmationModal.propTypes = {
  modals: PropTypes.objectOf(PropTypes.bool).isRequired,
  setOpenModal: PropTypes.func.isRequired,
  confirmationType: PropTypes.string.isRequired,
  confirmedFunction: PropTypes.func.isRequired,
  informationalHeader: PropTypes.string.isRequired,
  contentOverButtons: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  contentUnderButtons: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
};
